






import { Component, Vue } from "vue-property-decorator";
import ToggleItem from "@/common/ui/components/ToggleItem.vue";
import { saveScheduleNotifion } from "@/api/service-api";

@Component({
  components: {
    ToggleItem
  }
})
export default class NotificationConfigScreen extends Vue {
  async handleSubmit(value: boolean) {
    try {
      await saveScheduleNotifion(value);
      this.$store.dispatch("updateSchdeduleNotification", value);
    } catch (error) {
      alert(error);
    }
  }

  get service() {
    return this.$store.state.service;
  }
}
